import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { tokenSet } from 'components/login/dispatcher';


// this component is use to token wrapper on page refresh or on going back
const TokenSetWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(tokenSet());
  }, [dispatch, location]);

  return children;
};

export default TokenSetWrapper;
